var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-user-details" }, [
    _c("div", { staticClass: "c-user-details_content" }, [
      _c(
        "form",
        { attrs: { novalidate: "" } },
        [
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _c("form-select", {
                attrs: {
                  name: "title",
                  id: "aboutYouTitle",
                  label: _vm.aboutYouTitleLabel,
                  options: _vm.titleOptions,
                  required: true,
                  invalid: _vm.touched["title"] && _vm.titleError,
                  valid:
                    _vm.touched["title"] && _vm.title.length && !_vm.titleError,
                  validationMessage: _vm.titleError
                    ? "Please select your title"
                    : null,
                  value: _vm.innerTitle
                },
                on: {
                  change: function($event) {
                    return _vm.valueChange($event.value, "title")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _vm.showOtherTitle
                ? _c("text-field", {
                    attrs: {
                      name: "other-title",
                      id: "aboutYouOtherTitle",
                      label: _vm.aboutYouOtherTitleLabel,
                      required: true,
                      invalid: _vm.touched["otherTitle"] && _vm.otherTitleError,
                      valid:
                        _vm.touched["otherTitle"] &&
                        _vm.otherTitle.length &&
                        !_vm.otherTitleError,
                      validationMessage: _vm.otherTitleError
                        ? "Please enter your title"
                        : null,
                      value: _vm.innerOtherTitle
                    },
                    on: {
                      change: function($event) {
                        return _vm.valueChange($event, "otherTitle")
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _c("text-field", {
                attrs: {
                  name: "name",
                  id: "aboutYouFirstName",
                  label: _vm.aboutYouFirstNameLabel,
                  required: true,
                  invalid: _vm.touched["firstName"] && _vm.firstNameError,
                  valid:
                    _vm.touched["firstName"] &&
                    _vm.firstName.length &&
                    !_vm.firstNameError,
                  validationMessage: _vm.firstNameError
                    ? "Please enter your first name"
                    : null,
                  value: _vm.innerFirstName
                },
                on: {
                  change: function($event) {
                    return _vm.valueChange($event, "firstName")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _c("text-field", {
                attrs: {
                  name: "surname",
                  id: "aboutYouSurname",
                  label: _vm.aboutYouSurnameLabel,
                  required: true,
                  invalid: _vm.touched["surname"] && _vm.surnameError,
                  valid:
                    _vm.touched["surname"] &&
                    _vm.surname.length &&
                    !_vm.surnameError,
                  validationMessage: _vm.surnameError
                    ? "Please enter your surname"
                    : null,
                  value: _vm.innerSurname
                },
                on: {
                  change: function($event) {
                    return _vm.valueChange($event, "surname")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _c("text-field", {
                attrs: {
                  name: "customerReferenceNumber",
                  id: "customerReferenceNumber",
                  label: _vm.aboutYouCustomerReferenceNumberLabel,
                  tooltip: true,
                  tooltipTitle: _vm.aboutYouCustomerReferenceNumberLabel,
                  tooltipMessage: _vm.aboutYouCustomerReferenceNumberTooltip,
                  isActiveTooltip: _vm.isActiveCustomerReferenceNumberTooltip,
                  invalid:
                    _vm.touched["customerReferenceNumber"] &&
                    _vm.customerReferenceNumberError,
                  valid:
                    _vm.touched["customerReferenceNumber"] &&
                    !_vm.customerReferenceNumberError,
                  validationMessage: _vm.customerReferenceNumberError
                    ? "Please enter a valid customer reference number"
                    : null,
                  value: _vm.innerCustomerReferenceNumber
                },
                on: {
                  change: function($event) {
                    return _vm.valueChange($event, "customerReferenceNumber")
                  },
                  toggleTooltip: function($event) {
                    return _vm.toggleTooltip(
                      $event,
                      _vm.aboutYouCustomerReferenceNumberLabel
                    )
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _c("text-field", {
                attrs: {
                  name: "email",
                  id: "aboutYouEmail",
                  required: true,
                  label: _vm.aboutYouEmailLabel,
                  tooltip: true,
                  tooltipTitle: _vm.aboutYouEmailLabel,
                  tooltipMessage: _vm.aboutYouEmailToolTip,
                  isActiveTooltip: _vm.isActiveEmailTooltip,
                  invalid: _vm.touched["email"] && _vm.emailError,
                  valid:
                    _vm.touched["email"] && _vm.email.length && !_vm.emailError,
                  validationMessage: _vm.emailError
                    ? "Please enter a valid email address"
                    : null,
                  value: _vm.innerEmail
                },
                on: {
                  change: function($event) {
                    return _vm.valueChange($event, "email")
                  },
                  toggleTooltip: function($event) {
                    return _vm.toggleTooltip($event, _vm.aboutYouEmailLabel)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _c("text-field", {
                attrs: {
                  name: "confirmEmail",
                  id: "aboutYouConfirmEmail",
                  required: true,
                  label: _vm.aboutYouConfirmEmailLabel,
                  invalid: _vm.touched["confirmEmail"] && _vm.confirmEmailError,
                  valid:
                    _vm.touched["confirmEmail"] &&
                    _vm.confirmEmail.length &&
                    !_vm.confirmEmailError,
                  validationMessage: _vm.confirmEmailError
                    ? "Your email address does not match"
                    : null,
                  value: _vm.innerConfirmEmail
                },
                on: {
                  change: function($event) {
                    return _vm.valueChange($event, "confirmEmail")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _c("dropdown-field", {
                attrs: {
                  inputLabel: _vm.aboutYouPrimaryContactLabel,
                  id: "aboutYouPrimaryContact",
                  selectLabel: "Please select",
                  type: "tel",
                  autocomplete: "mobile tel",
                  options: _vm.dropdownOptions,
                  required: true,
                  tooltip: true,
                  tooltipTitle: _vm.aboutYouPrimaryContactLabel,
                  tooltipMessage: _vm.aboutYouPrimaryContactToolTip,
                  isActiveTooltip: _vm.isActivePrimaryContactTooltip,
                  valid:
                    (_vm.touched["primaryContact"] ||
                      _vm.touched["primaryContactType"]) &&
                    _vm.primaryContact.length > 0 &&
                    _vm.primaryContactType.length > 0 &&
                    _vm.primaryContactFieldIsValid,
                  invalid:
                    (_vm.touched["primaryContact"] ||
                      _vm.touched["primaryContactType"]) &&
                    !!_vm.primaryContactValidationMsg &&
                    !_vm.primaryContactFieldIsValid,
                  validationMessage: _vm.primaryContactValidationMsg,
                  inputValue: _vm.innerPrimaryContact,
                  selectValue: _vm.innerPrimaryContactType
                },
                on: {
                  onInputValue: function($event) {
                    return _vm.valueChange($event, "primaryContact")
                  },
                  onSelectValue: function($event) {
                    return _vm.valueChange($event.value, "primaryContactType")
                  },
                  toggleTooltip: function($event) {
                    return _vm.toggleTooltip(
                      $event,
                      _vm.aboutYouPrimaryContactLabel
                    )
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _c("dropdown-field", {
                attrs: {
                  inputLabel: _vm.aboutYouSecondaryContactLabel,
                  id: "aboutYouSecondaryContact",
                  selectLabel: "Please select",
                  type: "tel",
                  autocomplete: "mobile tel",
                  options: _vm.dropdownOptions,
                  valid:
                    (_vm.touched["secondaryContact"] ||
                      _vm.touched["secondaryContactType"]) &&
                    _vm.secondaryContactFieldIsValid,
                  invalid:
                    (_vm.touched["secondaryContact"] ||
                      _vm.touched["secondaryContactType"]) &&
                    !_vm.secondaryContactFieldIsValid,
                  validationMessage: _vm.secondaryContactValidationMsg,
                  inputValue: _vm.innerSecondaryContact,
                  selectValue: _vm.innerSecondaryContactType
                },
                on: {
                  onInputValue: function($event) {
                    return _vm.valueChange($event, "secondaryContact")
                  },
                  onSelectValue: function($event) {
                    return _vm.valueChange($event.value, "secondaryContactType")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-form__group" },
            [
              _vm.aboutYouAdditionalNeedsDesc
                ? _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.aboutYouAdditionalNeedsDesc) +
                        "\n        "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("textarea-field", {
                attrs: {
                  label: _vm.aboutYouAdditionalNeedsLabel,
                  id: "additionalNeeds",
                  name: "additionalNeeds",
                  value: _vm.innerAdditionalNeeds,
                  invalid:
                    _vm.touched["additionalNeeds"] && _vm.additionalNeedsError,
                  valid:
                    _vm.touched["additionalNeeds"] && !_vm.additionalNeedsError,
                  validationMessage: _vm.additionalNeedsError
                    ? "Please enter less than 1000 characters"
                    : null,
                  tooltip: true,
                  tooltipTitle: _vm.aboutYouAdditionalNeedsLabel,
                  tooltipMessage: _vm.aboutYouAdditionalNeedsTooltip,
                  isActiveTooltip: _vm.isActiveAdditionalNeedsTooltip
                },
                on: {
                  change: function($event) {
                    return _vm.valueChange($event, "additionalNeeds")
                  },
                  toggleTooltip: function($event) {
                    return _vm.toggleTooltip(
                      $event,
                      _vm.aboutYouAdditionalNeedsLabel
                    )
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("action-buttons", {
            attrs: {
              prevLabel: _vm.backButtonText,
              nextLabel: _vm.continueButtonText
            },
            on: { onPrev: _vm.onPrev, onNext: _vm.checkForm }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3966da20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3966da20","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/_contact-us-rap/_vue/UserDetails.vue
// module id = 773
// module chunks = 0